export const BUCKETS = [
  { value: "local", label: "Local Grievances" },
  { value: "fwd_office", label: "FWD to Office" },
  { value: "terminations", label: "Terminations" },
];

export function bucketLabel(b) {
  return BUCKETS.find((x) => x.value === b)?.label || b;
}
